import { Text } from '@chakra-ui/react';

export default function FormFieldError({ message }) {
    return (
        <Text color={'red.400'}>{message}</Text>
    );
}
